import React, { useState, useEffect } from 'react';
import config from '../../config/config.json';
import '../../styles/Header.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import themeConfig from '../../config/themeConfig';
import { faPlus, faKey, faExclamationTriangle, faShareAlt } from '@fortawesome/free-solid-svg-icons';
import { useDashboard } from '../../context/DashboardContext';
import {getGlobalState} from "../../utils/globalState";
import {addAccessRequest, addDashboardError} from '../../utils/api';
import NewDashboardTour from "../NewDashboardTour";
import NewUserTour from "../NewUserTour";

const Header = ({ dashboardData, currentTheme }) => {
  const [showFaultForm, setShowFaultForm] = useState(false);
  const [showSharePopup, setShowSharePopup] = useState(false);
  const [showRequestAccessPopup, setShowRequestAccessPopup] = useState(false);
  const [faultDetails, setFaultDetails] = useState('');
  const { handleAddToMyDashboards } = useDashboard();
  const myUserId = getGlobalState().myUserId;
  const [runTour, setRunTour] = useState(false)

  useEffect(() => {
    const theme = themeConfig.themes[currentTheme];
    document.documentElement.style.setProperty('--left-nav-bg-color', theme.leftNavBackgroundColor);
    document.documentElement.style.setProperty('--text-color', theme.textColor);
  }, [currentTheme]);

  const handleReportFaultClick = () => {
    setShowFaultForm(true);
  };

  const handleCancelClick = () => {
    setShowFaultForm(false);
    setFaultDetails('');
  };

  const handleSubmitClick = async () => {
    try {
      // console.log('Fault details submitted:', myUserId, dashboardData.dashboard_id, faultDetails);
      const response = await addDashboardError(myUserId, dashboardData.dashboard_id, faultDetails);
      if (response.status === 'success'){
        alert('Fault details submitted successfully');
      }
      setShowFaultForm(false);
      setFaultDetails('');
    } catch (error) {
      console.error('Error submitting fault details:', error);
    }
  };

  const handleShareClick = () => {
    setShowSharePopup(true);
  };

  const handleShareCancelClick = () => {
    setShowSharePopup(false);
  };

  const handleCopyLinkClick = () => {
    const shareLink = `${config.appBaseUrl}/d_${dashboardData.dashboard_id}`;
    navigator.clipboard.writeText(shareLink);
    alert('Link copied to clipboard');
    setShowSharePopup(false);
  };

  const handleRequestAccessClick = async () => {
    try {
      const response = await addAccessRequest(myUserId, dashboardData.dashboard_id);
      if (response.status === 'success'){
        setShowRequestAccessPopup(true);
      }
    } catch (error) {
      console.error('Error submitting fault details:', error);
    }

  };

  const handleRequestAccessCancelClick = () => {
    setShowRequestAccessPopup(false);
  };

  const handleAddToMyDashboardsClick = async () => {
    const dashboard = { id: 'd_' + dashboardData.dashboard_id, label: dashboardData.dashboard_name };
    console.log('Add to My Dashboards:', dashboard);
    await handleAddToMyDashboards(dashboard);
  };

  return (
      <>
        <NewDashboardTour run={runTour} />
        <div className="header-container">
          <div style={{ fontSize: '20px', fontWeight: 'bold' }}>
            {dashboardData ? dashboardData.dashboard_name : 'Loading...'}
          </div>
          <div>
            <button className="add-button" style={{ margin: '0 5px' }} title="Add to My Dashboards" onClick={handleAddToMyDashboardsClick}><FontAwesomeIcon icon={faPlus} /></button>
            <button className="request-button" style={{ margin: '0 5px' }} title="Request Access" onClick={handleRequestAccessClick}><FontAwesomeIcon icon={faKey} /></button>
            <button className="report-button" style={{ margin: '0 5px' }} title="Report a Fault" onClick={handleReportFaultClick}><FontAwesomeIcon icon={faExclamationTriangle} /></button>
            <button className="share-button" style={{ margin: '0 5px' }} title="Share Dashboard" onClick={handleShareClick}><FontAwesomeIcon icon={faShareAlt} /></button>
          </div>
          {showFaultForm && (
              <div className="modal-container bg-white rounded-lg shadow-lg p-6 max-w-md mx-auto">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">Report a Fault</h3>
                <textarea
                    value={faultDetails}
                    onChange={(e) => setFaultDetails(e.target.value)}
                    placeholder="Please describe the fault"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 mb-4 min-h-[100px] resize-y"
                />
                <div className="flex justify-end space-x-3">
                  <button  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" onClick={handleSubmitClick}>Submit</button>
                  <button className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500" onClick={handleCancelClick}>Cancel</button>
                </div>
              </div>
          )}
          {showSharePopup && (
              <div className="modal-container bg-white rounded-lg shadow-lg p-6 max-w-md mx-auto">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">Share Dashboard</h3>
                <p className="text-gray-600 mb-4">Use the link below to share the dashboard:</p>
                <input
                    type="text"
                    readOnly
                    value={`${config.appBaseUrl}/d_${dashboardData.dashboard_id}`}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 mb-4"
                />
                <div className="flex justify-end space-x-3">
                  <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" onClick={handleCopyLinkClick}>Copy Link</button>
                  <button className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500" onClick={handleShareCancelClick}>Cancel</button>
                </div>
              </div>
          )}
          {showRequestAccessPopup && (
              <div className="modal-container">
                <h3>Request Access</h3>
                <p>An access request has been sent to {dashboardData.owner}</p>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <button onClick={handleRequestAccessCancelClick}>OK</button>
                </div>
              </div>
          )}
        </div>
      </>

  );
};

export default Header;